import Logo from "../../../assets/solutions-logo.webp"
import { Link } from "react-scroll";

const Navbar = () => {
    return (
        <nav className="navbar">
            <div className="inner">
                <img src={Logo} alt="AmorServ Solution" />
                <Link to="schedule" spy={true} smooth={true} offset={-100} duration={2000}>
                    <button>Talk To Us</button>
                </Link>
            </div>
        </nav>
    )
}

export default Navbar;